import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MODULES_MAINTENANCE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetModulesMaintenancePayload, ModulesMaintenance } from '../types/getModulesMaintenance.types';

export const MODULES_MAINTENANCE_TAGS = 'getModulesMaintenance';

export const getModulesMaintenance = (builder: BuilderType) =>
  builder.query<ModulesMaintenance[], GetModulesMaintenancePayload | undefined>({
    providesTags: [MODULES_MAINTENANCE_TAGS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_MODULES_MAINTENANCE_URL,
    }),
    transformResponse: (response: GenericApiResponse<ModulesMaintenance[]>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
